import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import FloatContacts from "./FloatContacts";
import OrderModal from "@components/forms/OrderModal";
import { useScrollTop } from "@hooks/useScrollTop";

export default function PageLayout() {
  useScrollTop();

  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <FloatContacts />
      <OrderModal />
    </>
  );
}
